import { useEffect, useState } from "react";

import { obtenerPeriodoVigente } from "../services/bibliotecaApi";

/**
 * Carga el periodo academico vigente. El formulario solo lo muestra: no sabe
 * de donde sale ni tiene que manejar el estado de carga.
 *
 * @returns {{ periodo: string, cargando: boolean }}
 */
export const usePeriodoVigente = () => {
  const [periodo, setPeriodo] = useState("");
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    let vigente = true;

    obtenerPeriodoVigente()
      .then((nombre) => {
        if (!vigente) return;
        setPeriodo(nombre);
        setCargando(false);
      })
      .catch(() => {
        if (!vigente) return;
        setPeriodo("");
        setCargando(false);
      });

    // Evita el setState sobre un componente ya desmontado si el usuario
    // cambia de pestaña antes de que responda el API.
    return () => {
      vigente = false;
    };
  }, []);

  return { periodo, cargando };
};
